//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from "vuex";
import messages from '../store/modules/messages';

export default {
  computed: {
    ...mapState({
      controlPoints: state => state.drilling.controlPoints
    }),
    // msg to inform this is the end of drilling, no more choices available
    ...mapGetters("messages", ["extraLogsOutput"]) 
  },

  data: function() {
    return {
      title: "Control Points"
    };
  }
};
